import { render, staticRenderFns } from "./AanvullendeVragenToonPersoonsgegevens.vue?vue&type=template&id=0156b2ea"
import script from "./AanvullendeVragenToonPersoonsgegevens.vue?vue&type=script&lang=ts"
export * from "./AanvullendeVragenToonPersoonsgegevens.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports